import decodeToken from 'jwt-decode'
import config from '@/config'
import parseUrlHash from '@/utils/parse-url-hash'

export default {
  /**
   * @param {string} token
   */
  writeToken (token) {
    config.authStorageDriver.Write(token)
  },
  /**
   * @returns {string} auth token
   */
  GetToken () {
    return config.authStorageDriver.Read()
  },
  /**
   * @returns {AuthToken} decoded auth token
   */
  GetDecodedToken () {
    return decodeToken(this.GetToken())
  },
  /**
   * @returns {string[]} scopes
   */
  getScopes () {
    return this.GetDecodedToken().scopes
  },
  /**
   * @param {string} entity
   * @returns {boolean}
   */
  canManage (entity) {
    const scopes = this.getScopes()
    const scopesAmount = scopes.length

    for (let i = 0; i < scopesAmount; ++i) {
      if (scopes[i][`manage:${entity}`] === '1') {
        return true
      }
    }

    return false
  },
  CanManageOrgs () {
    return this.canManage('organizations')
  },
  CanManageMembers () {
    return this.canManage('members')
  },
  CanManageDocs () {
    return this.canManage('documents')
  },
  CanManageAny () {
    const entities = ['organizations', 'members', 'documents']
    return entities.some(entity => this.canManage(entity))
  },
  /**
   * @param {string[]} scopes
   * @returns {boolean}
   */
  CanManageAgainst (scopes) {
    return scopes.some(scope => this.canManage(scope))
  },
  removeToken () {
    config.authStorageDriver.Remove()
  },
  /**
   * @returns {string} auth token
   */
  Login (token) {
    this.writeToken(token)
    window.location.hash = null
  },
  Logout () {
    this.removeToken()
    window.location.href = config.ssoSignOutUrl
  },
  CleanUpSession () {
    this.removeToken()
  },
  /**
   * Returns true if token expired
   *
   * @returns {boolean}
   */
  IsTokenExpired () {
    const decodedToken = this.GetDecodedToken()

    return decodedToken.exp < Math.round(new Date().getTime() / 1000)
  },
  /**
   * @returns {boolean}
   */
  IsLoggedIn () {
    const token = this.GetToken()
    return token !== null && token.length > 0
  },
  /**
   * @returns {string|null}
   */
  DetectTokenInUrl () {
    const params = parseUrlHash()

    return Object.keys(params).length === 1 && params.hasOwnProperty('code') ? params.code : null
  },
  GoToSso () {
    window.location.href = config.ssoSignInUrl
  }
}



// WEBPACK FOOTER //
// ./src/common/auth/index.js